import { render, staticRenderFns } from "./industryActivity.vue?vue&type=template&id=0be77e2b&scoped=true"
import script from "./industryActivity.vue?vue&type=script&lang=js"
export * from "./industryActivity.vue?vue&type=script&lang=js"
import style0 from "./industryActivity.vue?vue&type=style&index=0&id=0be77e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be77e2b",
  null
  
)

export default component.exports